import { Component, inject } from '@angular/core'
import { Store } from '@ngrx/store'
import { eps } from '../../../../services/url.service'
import { selectRunningPayroll } from '../../../../store/contractor-payroll/contractor-payroll.reducers'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'

@Component({
  selector: 'app-success',
  imports: [CommonModule, RouterModule],
  templateUrl: './success.component.html',
  styleUrl: './success.component.scss'
})
export class SuccessComponent {
  private store = inject(Store)
  eps = eps
  runningPayroll$ = this.store.select(selectRunningPayroll)
}
